(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setPosition(compare, percent) {
      var value = Math.min(100, Math.max(0, percent));
      compare.style.setProperty('--compare-position', value + '%');

      var range = compare.querySelector('[data-compare-range]');
      if (range) range.value = String(Math.round(value));
    }

    function updateCompareWidth(compare) {
      var frame = compare.querySelector('[data-compare-frame]');
      if (!frame) return;
      compare.style.setProperty('--compare-width', frame.offsetWidth + 'px');
    }

    function initCompare(compare) {
      if (compare.dataset.initialized) return;
      compare.dataset.initialized = 'true';

      var frame = compare.querySelector('[data-compare-frame]');
      var handle = compare.querySelector('[data-compare-handle]');
      var range = compare.querySelector('[data-compare-range]');
      if (!frame) return;

      var dragging = false;

      function positionFromEvent(clientX) {
        var rect = frame.getBoundingClientRect();
        var x = clientX - rect.left;
        return (x / rect.width) * 100;
      }

      function startDrag() {
        dragging = true;
        frame.classList.add('is-dragging');
      }

      function endDrag() {
        dragging = false;
        frame.classList.remove('is-dragging');
      }

      frame.addEventListener('pointerdown', function (event) {
        if (event.button !== 0) return;
        startDrag();
        setPosition(compare, positionFromEvent(event.clientX));
        frame.setPointerCapture(event.pointerId);
      });

      frame.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        setPosition(compare, positionFromEvent(event.clientX));
      });

      frame.addEventListener('pointerup', endDrag);
      frame.addEventListener('pointercancel', endDrag);

      frame.addEventListener('click', function (event) {
        if (event.target.closest('[data-compare-handle]')) return;
        setPosition(compare, positionFromEvent(event.clientX));
      });

      if (handle) {
        handle.addEventListener('keydown', function (event) {
          var rangeEl = compare.querySelector('[data-compare-range]');
          var current = rangeEl ? parseFloat(rangeEl.value) : 85;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setPosition(compare, current - 2);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            setPosition(compare, current + 2);
          }
        });
      }

      if (range) {
        range.addEventListener('input', function () {
          setPosition(compare, parseFloat(range.value));
        });
      }

      updateCompareWidth(compare);
      window.addEventListener('resize', function () {
        updateCompareWidth(compare);
      });

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          updateCompareWidth(compare);
        }).observe(frame);
      }
    }

    function initAll(root) {
      root.querySelectorAll('[data-before-after-compare]').forEach(initCompare);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefit-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBenefitCarousel(root) {
      root.querySelectorAll('[data-benefit-carousel]').forEach(function (carousel) {
        if (carousel.dataset.initialized) return;
        carousel.dataset.initialized = 'true';

        var track = carousel.querySelector('.benefit-list__track');
        if (!track) return;

        var items = track.querySelectorAll('.benefit-list__item');
        if (items.length <= 2) return;

        var slideIndex = 0;
        var intervalId = null;
        var speed = (parseInt(carousel.dataset.autoplaySpeed, 10) || 4) * 1000;
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var mobileQuery = window.matchMedia('(max-width: 749px)');

        function slideCount() {
          return Math.ceil(items.length / 2);
        }

        function isMobile() {
          return mobileQuery.matches;
        }

        function goToSlide(index) {
          if (!isMobile()) {
            track.scrollTo({ left: 0, behavior: 'auto' });
            return;
          }

          var count = slideCount();
          slideIndex = ((index % count) + count) % count;
          track.scrollTo({
            left: slideIndex * track.clientWidth,
            behavior: reducedMotion ? 'auto' : 'smooth',
          });
        }

        function stopAutoplay() {
          if (intervalId) {
            window.clearInterval(intervalId);
            intervalId = null;
          }
        }

        function startAutoplay() {
          stopAutoplay();
          if (!isMobile() || reducedMotion || items.length <= 2) return;

          intervalId = window.setInterval(function () {
            goToSlide(slideIndex + 1);
          }, speed);
        }

        function updateMode() {
          if (isMobile()) {
            goToSlide(slideIndex);
            startAutoplay();
          } else {
            stopAutoplay();
            slideIndex = 0;
            track.scrollTo({ left: 0, behavior: 'auto' });
          }
        }

        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
        carousel.addEventListener('focusin', stopAutoplay);
        carousel.addEventListener('focusout', startAutoplay);

        window.addEventListener('resize', updateMode);
        mobileQuery.addEventListener('change', updateMode);

        updateMode();
      });
    }

    initBenefitCarousel(document);

    document.addEventListener('shopify:section:load', function (event) {
      initBenefitCarousel(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var inner = drawer.querySelector('[data-cart-drawer-inner]');
    var panel = drawer.querySelector('.cart-drawer__panel');
    var reservationMinutes = parseInt(drawer.dataset.reservationMinutes, 10) || 4;
    var reservationTimer = null;
    var reservationEndsAt = null;
    var closeTimer = null;
    var ANIMATION_MS = 320;

    function updateHeaderCount(count) {
      document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
        if (count > 0) {
          el.textContent = count;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
    }

    function formatTime(seconds) {
      var mins = Math.floor(seconds / 60);
      var secs = seconds % 60;
      return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
    }

    function stopReservationTimer() {
      if (reservationTimer) {
        window.clearInterval(reservationTimer);
        reservationTimer = null;
      }
    }

    function startReservationTimer() {
      stopReservationTimer();
      var timerEl = drawer.querySelector('[data-cart-reservation]');
      var textEl = drawer.querySelector('[data-cart-reservation-text]');
      if (!timerEl || !textEl) return;

      reservationEndsAt = Date.now() + reservationMinutes * 60 * 1000;
      timerEl.hidden = false;

      function tick() {
        var remaining = Math.max(0, Math.round((reservationEndsAt - Date.now()) / 1000));
        textEl.textContent = 'Cart reserved for ' + formatTime(remaining);
        if (remaining <= 0) stopReservationTimer();
      }

      tick();
      reservationTimer = window.setInterval(tick, 1000);
    }

    function bindDrawerEvents() {
      drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });

      drawer.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          changeLine(btn.dataset.cartRemove, 0);
        });
      });

      drawer.querySelectorAll('[data-cart-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var lineKey = btn.dataset.lineKey;
          var delta = parseInt(btn.dataset.cartQtyChange, 10);
          var row = btn.closest('[data-cart-line]');
          var qtyEl = row && row.querySelector('[data-cart-qty-value]');
          var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
          changeLine(lineKey, Math.max(0, current + delta));
        });
      });

      drawer.querySelectorAll('[data-cart-clear]').forEach(function (btn) {
        btn.addEventListener('click', clearCart);
      });

      drawer.querySelectorAll('[data-cart-checkout]').forEach(function (btn) {
        btn.addEventListener('click', goToCheckout);
      });
    }

    function parseSectionHtml(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshInner = doc.querySelector('[data-cart-drawer-inner]');
      return freshInner ? freshInner.innerHTML : html;
    }

    function consolidateCartByVariant() {
      var cartUrl = drawer.dataset.cartUrl || '/cart.js';

      return fetch(cartUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then(parseCartResponse)
        .then(function (cart) {
          var byVariant = {};

          cart.items.forEach(function (item) {
            var variantKey = String(item.variant_id);
            if (!byVariant[variantKey]) byVariant[variantKey] = [];
            byVariant[variantKey].push(item);
          });

          var updates = {};
          Object.keys(byVariant).forEach(function (variantKey) {
            var lines = byVariant[variantKey];
            if (lines.length <= 1) return;

            var totalQty = lines.reduce(function (sum, line) {
              return sum + line.quantity;
            }, 0);

            updates[lines[0].key] = totalQty;
            for (var i = 1; i < lines.length; i += 1) {
              updates[lines[i].key] = 0;
            }
          });

          if (Object.keys(updates).length === 0) return null;

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }).then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                throw new Error(data.description || data.message || 'Could not update cart');
              }
              return data;
            });
          });
        })
        .catch(function () {
          return null;
        });
    }

    function refresh() {
      var sectionId = 'cart-drawer';
      return consolidateCartByVariant()
        .then(function () {
          return fetch('/?sections=' + sectionId, {
            headers: { Accept: 'application/json' },
          });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!data[sectionId]) return;
          inner.innerHTML = parseSectionHtml(data[sectionId]);
          bindDrawerEvents();
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          if (!response) return;
          return response.json();
        })
        .then(function (cart) {
          if (cart) updateHeaderCount(cart.item_count);
        });
    }

    function goToCheckout() {
      var checkoutUrl = drawer.dataset.checkoutUrl || '/checkout';
      window.location.assign(checkoutUrl);
    }

    function parseCartResponse(response) {
      var contentType = response.headers.get('content-type') || '';

      return response.text().then(function (text) {
        var isJson =
          contentType.indexOf('json') !== -1 ||
          contentType.indexOf('javascript') !== -1 ||
          (text.trim().charAt(0) === '{' || text.trim().charAt(0) === '[');

        if (!isJson) {
          throw new Error('Could not reach the cart. Please refresh the page and try again.');
        }

        var data;
        try {
          data = JSON.parse(text);
        } catch (parseError) {
          throw new Error('Could not update the cart. Please try again.');
        }

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not update the cart');
        }

        return data;
      });
    }

    function clearCart() {
      if (!window.confirm('Remove all items from your cart?')) return;

      var clearUrl = drawer.dataset.cartClearUrl || '/cart/clear.js';
      var updateUrl = drawer.dataset.cartUpdateUrl || '/cart/update.js';
      var cartUrl = drawer.dataset.cartUrl || '/cart.js';

      function clearViaUpdate(cart) {
        if (!cart.items || cart.items.length === 0) return cart;

        var updates = {};
        cart.items.forEach(function (item) {
          updates[item.key] = 0;
        });

        return fetch(updateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(parseCartResponse);
      }

      return fetch(clearUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: '{}',
      })
        .then(parseCartResponse)
        .catch(function () {
          return fetch(cartUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          })
            .then(parseCartResponse)
            .then(clearViaUpdate);
        })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          stopReservationTimer();
          var timerEl = drawer.querySelector('[data-cart-reservation]');
          if (timerEl) timerEl.hidden = true;
          return refresh();
        })
        .catch(function (err) {
          window.alert(err.message);
        });
    }

    function changeLine(lineKey, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity }),
      }).then(parseCartResponse)
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          return refresh();
        })
        .then(function () {
          if (drawer.querySelector('.cart-drawer__item') == null) {
            stopReservationTimer();
            var timerEl = drawer.querySelector('[data-cart-reservation]');
            if (timerEl) timerEl.hidden = true;
          }
        })
        .catch(function (err) {
          window.alert(err.message);
        });
    }

    function open() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('data-cart-drawer-open', '');

      // Paint off-screen state before sliding in (hidden/display:none skips transitions)
      void drawer.offsetHeight;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          startReservationTimer();
          if (panel) panel.focus();
        });
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('data-cart-drawer-open');
      stopReservationTimer();
      closeTimer = window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        closeTimer = null;
      }, ANIMATION_MS);
    }

    function openAndRefresh() {
      open();
      refresh();
    }

    window.CartDrawer = {
      open: open,
      close: close,
      refresh: refresh,
      openAndRefresh: openAndRefresh,
    };

    bindDrawerEvents();

    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openAndRefresh();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    if (sessionStorage.getItem('openCartDrawer')) {
      sessionStorage.removeItem('openCartDrawer');
      openAndRefresh();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-block"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initContentBlockVideos(root) {
      root.querySelectorAll('[data-content-block-video]').forEach(function (wrap) {
        if (wrap.dataset.initialized) return;
        wrap.dataset.initialized = 'true';

        var video = wrap.querySelector('video');
        if (!video) return;

        wrap.addEventListener('click', function () {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      });
    }

    initContentBlockVideos(document);

    document.addEventListener('shopify:section:load', function (event) {
      initContentBlockVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseReviewDate(value) {
      if (!value) return 0;
      var parts = value.split(/[/-]/);
      if (parts.length === 3) {
        return new Date(parts[2], parts[0] - 1, parts[1]).getTime();
      }
      return Date.parse(value) || 0;
    }

    function initCustomerReviews(root) {
      root.querySelectorAll('[data-customer-reviews]').forEach(function (section) {
        if (section.dataset.initialized) return;
        section.dataset.initialized = 'true';

        var list = section.querySelector('[data-reviews-list]');
        var sortSelect = section.querySelector('[data-reviews-sort]');
        var pagination = section.querySelector('[data-reviews-pagination]');
        var backTop = section.querySelector('[data-reviews-back-top]');
        if (!list) return;

        var perPage = parseInt(section.dataset.reviewsPerPage, 10) || 5;
        var items = Array.prototype.slice.call(section.querySelectorAll('[data-review-item]'));
        var currentPage = 1;

        function sortedItems() {
          var sortValue = sortSelect ? sortSelect.value : 'recent';
          return items.slice().sort(function (a, b) {
            if (sortValue === 'highest') {
              return parseInt(b.dataset.reviewRating, 10) - parseInt(a.dataset.reviewRating, 10);
            }
            if (sortValue === 'lowest') {
              return parseInt(a.dataset.reviewRating, 10) - parseInt(b.dataset.reviewRating, 10);
            }
            return parseReviewDate(b.dataset.reviewDate) - parseReviewDate(a.dataset.reviewDate);
          });
        }

        function renderPagination(pageCount) {
          if (!pagination) return;
          pagination.innerHTML = '';

          if (pageCount <= 1) {
            pagination.hidden = true;
            return;
          }

          pagination.hidden = false;

          for (var page = 1; page <= pageCount; page += 1) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'customer-reviews__page-btn' + (page === currentPage ? ' is-active' : '');
            button.textContent = String(page);
            button.dataset.page = String(page);
            button.addEventListener('click', function () {
              currentPage = parseInt(this.dataset.page, 10);
              render();
            });
            pagination.appendChild(button);
          }

          if (currentPage < pageCount) {
            ['>', '»'].forEach(function (label, index) {
              var nextButton = document.createElement('button');
              nextButton.type = 'button';
              nextButton.className = 'customer-reviews__page-btn';
              nextButton.textContent = label;
              nextButton.addEventListener('click', function () {
                currentPage = Math.min(pageCount, currentPage + (index === 0 ? 1 : pageCount - currentPage));
                render();
              });
              pagination.appendChild(nextButton);
            });
          }
        }

        function render() {
          var ordered = sortedItems();
          var pageCount = Math.max(1, Math.ceil(ordered.length / perPage));
          if (currentPage > pageCount) currentPage = pageCount;

          items.forEach(function (item) {
            item.hidden = true;
          });

          ordered.forEach(function (item, index) {
            var page = Math.floor(index / perPage) + 1;
            item.hidden = page !== currentPage;
            list.appendChild(item);
          });

          renderPagination(pageCount);
        }

        if (sortSelect) {
          sortSelect.addEventListener('change', function () {
            currentPage = 1;
            render();
          });
        }

        if (backTop) {
          window.addEventListener('scroll', function () {
            backTop.hidden = window.scrollY < 400;
          });

          backTop.addEventListener('click', function () {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });

          backTop.hidden = window.scrollY < 400;
        }

        render();
      });
    }

    initCustomerReviews(document);

    document.addEventListener('shopify:section:load', function (event) {
      initCustomerReviews(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      root.querySelectorAll('[data-faq-section]').forEach(function (section) {
        if (section.dataset.initialized) return;
        section.dataset.initialized = 'true';

        section.querySelectorAll('[data-faq-item]').forEach(function (item) {
          var trigger = item.querySelector('[data-faq-trigger]');
          if (!trigger) return;

          trigger.addEventListener('click', function () {
            var isOpen = item.classList.contains('is-open');

            section.querySelectorAll('[data-faq-item]').forEach(function (other) {
              other.classList.remove('is-open');
              var otherTrigger = other.querySelector('[data-faq-trigger]');
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            });

            if (!isOpen) {
              item.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');
            }
          });
        });
      });
    }

    initFaq(document);

    document.addEventListener('shopify:section:load', function (event) {
      initFaq(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function closeMenu(header, overlay, toggle) {
      overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.documentElement.removeAttribute('data-menu-open');

      window.setTimeout(function () {
        if (!overlay.classList.contains('is-open')) {
          overlay.hidden = true;
        }
      }, 200);
    }

    function openMenu(header, overlay, toggle) {
      overlay.hidden = false;
      window.requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      document.documentElement.setAttribute('data-menu-open', '');
    }

    function initHeaderMenu(root) {
      root.querySelectorAll('[data-header-menu]').forEach(function (header) {
        if (header.dataset.initialized) return;
        header.dataset.initialized = 'true';

        var toggle = header.querySelector('[data-menu-toggle]');
        var overlay = header.querySelector('[data-menu-overlay]');
        var closeBtn = header.querySelector('[data-menu-close]');

        if (!toggle || !overlay) return;

        toggle.addEventListener('click', function () {
          if (overlay.classList.contains('is-open')) {
            closeMenu(header, overlay, toggle);
          } else {
            openMenu(header, overlay, toggle);
          }
        });

        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            closeMenu(header, overlay, toggle);
          });
        }

        overlay.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', function () {
            closeMenu(header, overlay, toggle);
          });
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
            closeMenu(header, overlay, toggle);
          }
        });
      });
    }

    initHeaderMenu(document);

    document.addEventListener('shopify:section:load', function (event) {
      initHeaderMenu(event.target);
    });

    function initHeaderScroll() {
      if (window.__headerScrollInitialized) return;
      window.__headerScrollInitialized = true;

      var header = document.querySelector('[data-header-scroll]');
      if (!header) return;

      var lastWindowScroll = 0;
      var scrollThreshold = 12;

      function updateHeaderOffset() {
        var hidden = header.classList.contains('is-hidden');
        var height = header.offsetHeight;
        document.documentElement.style.setProperty('--site-header-height', height + 'px');
        document.documentElement.style.setProperty(
          '--site-header-offset',
          hidden ? '0px' : height + 'px'
        );
      }

      function setHeaderHidden(hidden) {
        if (document.documentElement.hasAttribute('data-menu-open')) return;

        header.classList.toggle('is-hidden', hidden);
        document.documentElement.toggleAttribute('data-header-hidden', hidden);
        updateHeaderOffset();
      }

      function onScrollPosition(currentY, lastY) {
        if (document.documentElement.hasAttribute('data-menu-open')) return;

        if (currentY <= scrollThreshold) {
          setHeaderHidden(false);
          return lastY;
        }

        if (currentY > lastY + 2) {
          setHeaderHidden(true);
        } else if (currentY < lastY - 2) {
          setHeaderHidden(false);
        }

        return currentY;
      }

      function onWindowScroll() {
        lastWindowScroll = onScrollPosition(window.scrollY, lastWindowScroll);
      }

      window.addEventListener('scroll', onWindowScroll, { passive: true });
      window.addEventListener('resize', updateHeaderOffset);

      updateHeaderOffset();
      onWindowScroll();
    }

    initHeaderScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activateTab(section, index) {
      var tabs = section.querySelectorAll('[data-how-to-use-tab]');
      var panels = section.querySelectorAll('[data-how-to-use-panel]');
      var navLabel = section.querySelector('[data-how-to-use-nav-label]');

      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel, panelIndex) {
        var isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;

        if (!isActive) {
          panel.querySelectorAll('video').forEach(function (video) {
            video.pause();
          });
        }
      });

      if (navLabel && tabs[index]) {
        navLabel.textContent = tabs[index].textContent.trim() + ' selected';
      }
    }

    function initHowToUseVideos(root) {
      root.querySelectorAll('[data-how-to-use-video]').forEach(function (wrap) {
        if (wrap.dataset.initialized) return;
        wrap.dataset.initialized = 'true';

        var video = wrap.querySelector('video');
        if (!video) return;

        wrap.addEventListener('click', function () {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      });
    }

    function initHowToUseTabs(root) {
      root.querySelectorAll('[data-how-to-use-tabs]').forEach(function (section) {
        if (section.dataset.initialized) return;
        section.dataset.initialized = 'true';

        var tabs = section.querySelectorAll('[data-how-to-use-tab]');
        if (!tabs.length) return;

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            activateTab(section, parseInt(tab.dataset.tabIndex, 10));
          });

          tab.addEventListener('keydown', function (event) {
            var currentIndex = parseInt(tab.dataset.tabIndex, 10);
            var nextIndex = currentIndex;

            if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            if (nextIndex === currentIndex) return;

            event.preventDefault();
            activateTab(section, nextIndex);
            tabs[nextIndex].focus();
          });
        });

        activateTab(section, 0);
      });
    }

    initHowToUseVideos(document);
    initHowToUseTabs(document);

    document.addEventListener('shopify:section:load', function (event) {
      initHowToUseVideos(event.target);
      initHowToUseTabs(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function formatOrdinal(day) {
      if (day % 10 === 1 && day % 100 !== 11) return day + 'st';
      if (day % 10 === 2 && day % 100 !== 12) return day + 'nd';
      if (day % 10 === 3 && day % 100 !== 13) return day + 'rd';
      return day + 'th';
    }

    function formatDate(date) {
      var month = date.toLocaleString(undefined, { month: 'long' });
      return month + ' ' + formatOrdinal(date.getDate());
    }

    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }

    function initAccordions(section) {
      section.querySelectorAll('[data-product-accordion]').forEach(function (item) {
        var trigger = item.querySelector('[data-accordion-trigger]');
        var panel = item.querySelector('[data-accordion-panel]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function () {
          var isOpen = item.classList.toggle('is-open');
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          panel.hidden = !isOpen;

          if (section.updateProductScrollHeight) {
            window.requestAnimationFrame(function () {
              section.updateProductScrollHeight();
            });
          }
        });
      });
    }

    function initDeliveryTimeline(section) {
      if (!section) return;

      var orderedEl = section.querySelector('[data-delivery-ordered]');
      if (!orderedEl) return;

      var readyDays = parseInt(section.dataset.readyDays, 10) || 1;
      var deliveredStart = parseInt(section.dataset.deliveredStartDays, 10) || 2;
      var deliveredEnd = parseInt(section.dataset.deliveredEndDays, 10) || 3;

      var today = new Date();
      var readyEnd = addDays(today, readyDays);
      var deliveredStartDate = addDays(today, deliveredStart);
      var deliveredEndDate = addDays(today, deliveredEnd);

      orderedEl.textContent = formatDate(today);

      var readyEl = section.querySelector('[data-delivery-ready]');
      if (readyEl) {
        if (readyDays === 0) {
          readyEl.textContent = formatDate(today);
        } else {
          readyEl.textContent = formatDate(today) + ' \u2013 ' + formatDate(readyEnd);
        }
      }

      var deliveredEl = section.querySelector('[data-delivery-delivered]');
      if (deliveredEl) {
        if (deliveredStart === deliveredEnd) {
          deliveredEl.textContent = formatDate(deliveredStartDate);
        } else {
          deliveredEl.textContent =
            formatDate(deliveredStartDate) + ' \u2013 ' + formatDate(deliveredEndDate);
        }
      }
    }

    function getProductData(section) {
      var jsonEl = section.querySelector('[data-product-json]');
      if (!jsonEl) return null;
      return JSON.parse(jsonEl.textContent);
    }

    function findVariantByOptions(variants, options) {
      return variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    function getVariantForColorValue(section, colorValue, colorOptionIndex) {
      var data = getProductData(section);
      if (!data) return null;

      var variants = data.variants;
      var template = variants.find(function (v) {
        return v.available;
      }) || variants[0];
      if (!template) return null;

      var options = template.options.slice();
      options[colorOptionIndex] = colorValue;

      return (
        findVariantByOptions(variants, options) ||
        variants.find(function (variant) {
          return variant.options[colorOptionIndex] === colorValue;
        })
      );
    }

    function setMainImage(mainImage, src, alt, srcset) {
      if (!mainImage || !src) return;

      mainImage.src = src;
      mainImage.alt = alt || '';

      if (srcset) {
        mainImage.srcset = srcset;
      } else {
        mainImage.removeAttribute('srcset');
      }

      var picture = mainImage.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function (source) {
          source.remove();
        });
      }
    }

    function updateMainImageFromVariant(section, variant) {
      if (!variant) return;
      var mainImage = section.querySelector('.product-page__main-image');
      if (!mainImage) return;

      if (variant.featured_media && variant.featured_media.id) {
        var thumb = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb && thumb.dataset.imageSrc) {
          setMainImage(
            mainImage,
            thumb.dataset.imageSrc,
            thumb.dataset.imageAlt,
            thumb.dataset.imageSrcset
          );
          section.querySelectorAll('[data-thumb-index]').forEach(function (t) {
            t.classList.toggle('product-page__thumb--active', t === thumb);
          });
          return;
        }
      }

      if (variant.featured_image && variant.featured_image.src) {
        setMainImage(mainImage, variant.featured_image.src, variant.featured_image.alt, '');
      }
    }

    function createBundleGroupId() {
      return (
        'bundle-' +
        Date.now().toString(36) +
        '-' +
        Math.random().toString(36).slice(2, 8)
      );
    }

    function getBundleProperties(selectedBundle, bundleGroupId, extraProperties) {
      var props = {
        'Bundle tier': selectedBundle.dataset.bundleTitle || 'Buy 1',
        _bundle_size: String(parseInt(selectedBundle.dataset.bundleQuantity, 10) || 1),
        _bundle_group: bundleGroupId,
      };

      if (extraProperties) {
        Object.keys(extraProperties).forEach(function (key) {
          if (extraProperties[key] != null && extraProperties[key] !== '') {
            props[key] = extraProperties[key];
          }
        });
      }

      return props;
    }

    function buildCartItems(section) {
      var data = getProductData(section);
      if (!data) return [];

      var selectedBundle = section.querySelector('[data-bundle-index]:checked');
      if (!selectedBundle) return [];

      var bundleCard = selectedBundle.closest('[data-bundle-card]');
      var bundleVariantId = selectedBundle.dataset.bundleVariantId;
      var bundleGroupId = createBundleGroupId();
      var colorSelects =
        bundleCard && bundleCard.querySelectorAll('[data-bundle-color-select]');

      if (colorSelects && colorSelects.length > 0) {
        var colorOptionIndex = data.colorOptionIndex || 0;
        var byVariant = {};

        colorSelects.forEach(function (select) {
          var variant = getVariantForColorValue(section, select.value, colorOptionIndex);
          if (!variant) return;

          var variantKey = String(variant.id);
          if (!byVariant[variantKey]) {
            byVariant[variantKey] = {
              id: variant.id,
              quantity: 0,
              color: select.value,
              slots: [],
            };
          }

          byVariant[variantKey].quantity += 1;
          var slot = select.dataset.bundleColorSlot;
          if (slot) {
            byVariant[variantKey].slots.push('#' + slot);
          }
        });

        return Object.keys(byVariant).map(function (variantKey) {
          var entry = byVariant[variantKey];
          var extra = { Color: entry.color };
          if (entry.slots.length) {
            extra['Color slot'] = entry.slots.join(', ');
          }

          return {
            id: parseInt(entry.id, 10),
            quantity: entry.quantity,
            properties: getBundleProperties(selectedBundle, bundleGroupId, extra),
          };
        });
      }

      if (bundleVariantId) {
        return [
          {
            id: parseInt(bundleVariantId, 10),
            quantity: 1,
            properties: getBundleProperties(selectedBundle, bundleGroupId),
          },
        ];
      }

      var quantity = parseInt(selectedBundle.dataset.bundleQuantity, 10) || 1;
      var variant =
        data.variants.find(function (v) {
          return v.available;
        }) || data.variants[0];

      if (!variant) return [];
      return [
        {
          id: parseInt(variant.id, 10),
          quantity: quantity,
          properties: getBundleProperties(selectedBundle, bundleGroupId),
        },
      ];
    }

    function parseCartResponse(response) {
      var contentType = response.headers.get('content-type') || '';

      return response.text().then(function (text) {
        var isJson =
          contentType.indexOf('json') !== -1 ||
          contentType.indexOf('javascript') !== -1 ||
          (text.trim().charAt(0) === '{' || text.trim().charAt(0) === '[');

        if (!isJson) {
          throw new Error('Could not reach the cart. Please refresh the page and try again.');
        }

        var data;
        try {
          data = JSON.parse(text);
        } catch (parseError) {
          throw new Error('Could not update the cart. Please try again.');
        }

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not update the cart');
        }

        return data;
      });
    }

    function getCartApiUrls(section) {
      return {
        cart: section.dataset.cartUrl || '/cart.js',
        add: section.dataset.cartAddUrl || '/cart/add.js',
        clear: section.dataset.cartClearUrl || '/cart/clear.js',
        update: section.dataset.cartUpdateUrl || '/cart/update.js',
      };
    }

    function clearCartForBuyNow(section) {
      var urls = getCartApiUrls(section);

      function clearViaUpdate(cart) {
        if (!cart.items || cart.items.length === 0) return cart;

        var updates = {};
        cart.items.forEach(function (item) {
          updates[item.key] = 0;
        });

        return fetch(urls.update, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(parseCartResponse);
      }

      return fetch(urls.cart, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(parseCartResponse)
        .then(function (cart) {
          if (!cart.item_count) return cart;

          return fetch(urls.clear, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: '{}',
          })
            .then(parseCartResponse)
            .catch(function () {
              return clearViaUpdate(cart);
            });
        });
    }

    function initBundleSelection(section) {
      var defaultIndex = parseInt(section.dataset.defaultBundleIndex, 10);
      if (isNaN(defaultIndex) || defaultIndex < 0) defaultIndex = 0;

      var radios = section.querySelectorAll('[data-bundle-index]');
      if (!radios.length) return;

      var matched = false;
      radios.forEach(function (radio) {
        var index = parseInt(radio.value, 10);
        var isDefault = index === defaultIndex;
        radio.checked = isDefault;
        if (isDefault) matched = true;
      });

      if (!matched) {
        radios[0].checked = true;
      }
    }

    function updateBundleSelection(section) {
      var selectedRadio = section.querySelector('[data-bundle-index]:checked');
      var selected = selectedRadio && selectedRadio.closest('[data-bundle-card]');
      var firstColorSelect = selected && selected.querySelector('[data-bundle-color-select]');
      if (firstColorSelect) {
        var data = getProductData(section);
        var variant = getVariantForColorValue(
          section,
          firstColorSelect.value,
          data ? data.colorOptionIndex : 0
        );
        updateMainImageFromVariant(section, variant);
      }

      if (section.updateProductScrollHeight) {
        window.requestAnimationFrame(function () {
          section.updateProductScrollHeight();
        });
      }
    }

    function initGallery(section) {
      var mainImage = section.querySelector('.product-page__main-image');
      var thumbs = section.querySelectorAll('[data-thumb-index]');
      if (!mainImage || thumbs.length === 0) return;

      var activeIndex = 0;
      thumbs.forEach(function (thumb, index) {
        if (thumb.classList.contains('product-page__thumb--active')) {
          activeIndex = index;
        }
      });

      function setActive(index) {
        activeIndex = index;
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('product-page__thumb--active', i === index);
        });
        var active = thumbs[index];
        if (active) {
          setMainImage(
            mainImage,
            active.dataset.imageSrc,
            active.dataset.imageAlt,
            active.dataset.imageSrcset
          );
          active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          setActive(index);
        });
      });

      var prev = section.querySelector('[data-thumb-prev]');
      var next = section.querySelector('[data-thumb-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          setActive((activeIndex - 1 + thumbs.length) % thumbs.length);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          setActive((activeIndex + 1) % thumbs.length);
        });
      }
    }

    function showCartMessage(section, message, state) {
      var el = section.querySelector('[data-cart-message]');
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
      el.dataset.state = state;
    }

    function addToCart(section, redirectToCheckout, clearCartFirst) {
      var items = buildCartItems(section).filter(function (item) {
        return item.id && item.quantity > 0;
      });

      if (!items.length) {
        showCartMessage(section, 'Select a bundle option to continue', 'error');
        return;
      }

      var addBtn = section.querySelector('[data-add-to-cart]');
      var buyNowBtns = section.querySelectorAll('[data-buy-now]');
      if (addBtn) addBtn.disabled = true;
      buyNowBtns.forEach(function (btn) {
        btn.disabled = true;
      });

      var checkoutUrl = section.dataset.checkoutUrl || '/checkout';
      var urls = getCartApiUrls(section);

      var addRequest = function () {
        return fetch(urls.add, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        }).then(parseCartResponse);
      };

      var request = clearCartFirst ? clearCartForBuyNow(section).then(addRequest) : addRequest();

      request
        .then(function () {
          if (redirectToCheckout) {
            window.location.assign(checkoutUrl);
            return;
          }
          if (window.CartDrawer) {
            window.CartDrawer.openAndRefresh();
            return;
          }
          showCartMessage(section, 'Added to cart', 'success');
        })
        .catch(function (err) {
          showCartMessage(section, err.message, 'error');
        })
        .finally(function () {
          if (addBtn) addBtn.disabled = false;
          buyNowBtns.forEach(function (btn) {
            btn.disabled = false;
          });
        });
    }

    function initProductScrollLayout(section) {
      var grid = section.querySelector('.product-page__grid');
      var info = section.querySelector('.product-page__info');
      var gallery = section.querySelector('.product-page__gallery');
      if (!grid || !info || !gallery) return;

      var desktopQuery = window.matchMedia('(min-width: 750px)');
      var resizeObserver;

      function isDesktop() {
        return desktopQuery.matches;
      }

      function getHeaderOffset() {
        var value = getComputedStyle(document.documentElement).getPropertyValue('--site-header-offset');
        return parseFloat(value) || 0;
      }

      function updateGridMinHeight() {
        if (!isDesktop()) {
          grid.style.minHeight = '';
          return;
        }

        var headerOffset = getHeaderOffset();
        var viewport = window.innerHeight - headerOffset;
        var infoHeight = info.offsetHeight;
        var galleryHeight = gallery.offsetHeight;

        var minHeight = infoHeight + galleryHeight - viewport + headerOffset;
        minHeight = Math.max(minHeight, infoHeight, galleryHeight);

        grid.style.minHeight = Math.ceil(minHeight) + 'px';
      }

      function bind() {
        updateGridMinHeight();

        if (resizeObserver) resizeObserver.disconnect();

        resizeObserver = new ResizeObserver(updateGridMinHeight);
        resizeObserver.observe(info);
        resizeObserver.observe(gallery);
      }

      section.updateProductScrollHeight = updateGridMinHeight;

      bind();
      desktopQuery.addEventListener('change', bind);
      window.addEventListener('resize', updateGridMinHeight);
      window.addEventListener('load', updateGridMinHeight);

      new MutationObserver(updateGridMinHeight).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-header-hidden'],
      });
    }

    function initProductSection(root) {
      root.querySelectorAll('[data-product-section]').forEach(function (section) {
        if (section.dataset.initialized) return;
        section.dataset.initialized = 'true';

        initDeliveryTimeline(section);
        initAccordions(section);
        initGallery(section);
        initProductScrollLayout(section);
        initBundleSelection(section);

        section.querySelectorAll('[data-bundle-index]').forEach(function (input) {
          input.addEventListener('change', function () {
            updateBundleSelection(section);
          });
        });

        section.querySelectorAll('[data-bundle-color-select]').forEach(function (select) {
          select.addEventListener('change', function () {
            var data = getProductData(section);
            var variant = getVariantForColorValue(
              section,
              select.value,
              data ? data.colorOptionIndex : 0
            );
            updateMainImageFromVariant(section, variant);
          });

          select.addEventListener('click', function (event) {
            event.stopPropagation();
          });
        });

        var addBtn = section.querySelector('[data-add-to-cart]');
        if (addBtn) {
          addBtn.addEventListener('click', function () {
            addToCart(section, false, false);
          });
        }

        section.querySelectorAll('[data-buy-now]').forEach(function (buyNowBtn) {
          buyNowBtn.addEventListener('click', function () {
            addToCart(section, true, true);
          });
        });
      });
    }

    initProductSection(document);

    document.addEventListener('shopify:section:load', function (event) {
      initProductSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
